// Mağaza bağlantıları: tanıtım sayfalarında ortak.
export const APP_STORE_URL = "https://apps.apple.com/tr/app/terakki/id6757817264";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.adimadim.terakki&hl=tr";
